import * as React from 'react';

import {Body} from '../../typography/body';

import styles from './integrations-form-success.module.css';

export function IntegrationsFormSuccess() {
    return (
        <div className={styles['integration-form-success']}>
            <Body>
                Thanks for submitting your marketplace integration! Our team will be in touch in the
                next 2 business days.
            </Body>
        </div>
    );
}
